import { render, staticRenderFns } from "./my_shop.vue?vue&type=template&id=dff2fc04&scoped=true&"
import script from "./my_shop.vue?vue&type=script&lang=js&"
export * from "./my_shop.vue?vue&type=script&lang=js&"
import style0 from "./my_shop.vue?vue&type=style&index=0&id=dff2fc04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff2fc04",
  null
  
)

export default component.exports